var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twitter",
    d: "M8.90701 9.3155L0.717016 0H2.65778L9.76915 8.08852L15.449 0H22L13.411 12.2313L22 22H20.0591L12.5493 13.4583L6.55101 22H0L8.90749 9.3155H8.90701ZM11.5653 12.339L12.4356 11.1211L19.3598 1.42965H16.3787L10.7908 9.25094L9.92053 10.4689L2.65687 20.6354H5.63794L11.5653 12.3395V12.339Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0d2703065836700279d1823d80c3f138.svg";
export { ForwardRef as ReactComponent };